module.exports = __webpack_public_path__ + "static/media/enter_room.6cc9a470.svg";